import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Box, Paper, FormControl, Select } from '@material-ui/core';

const Filters = forwardRef(function Filters(props, ref) {
  const { activeFilter, options, onChange } = props;

  return (
    <Paper ref={ref} square>
      <Box px={2} py={1}>
        <FormControl>
          <Select
            native
            value={activeFilter}
            onChange={onChange}
            inputProps={{
              name: 'status',
              id: 'status-select',
            }}
          >
            {options.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
});

Filters.propTypes = {
  activeFilter: Type.string.isRequired,
  options: Type.arrayOf(
    Type.shape({
      label: Type.string,
      value: Type.string,
    }),
  ).isRequired,
  onChange: Type.func.isRequired,
};

export default Filters;
